import { Dispatch } from 'redux';
import { api } from '../config/axiosConfig';
import { workoutsConstants } from '../constants';

export const getWorkouts = () => {
    const request = () => (
        { type: workoutsConstants.WORKOUTS_REQUEST }
    );

    const success = (data: any) => (
        { type: workoutsConstants.WORKOUTS_SUCCESS, data }
    );

    const failure = (data: any) => (
        { type: workoutsConstants.WORKOUTS_FAILURE, data }
    );

    const requestURL = `/v1/workoutWeb/getWorkouts`;
    return (dispatch: Dispatch<any>) => {
        dispatch(request());
        api()
        .get(requestURL)
        .then((response) => { dispatch(success(response.data)); })
        .catch((error) => { dispatch(failure(error.data)); });
    };
};

export const getAllWorkouts = () => {
    const request = () => (
        { type: workoutsConstants.WORKOUTS_ALL_REQUEST }
    );

    const success = (data: any) => (
        { type: workoutsConstants.WORKOUTS_ALL_SUCCESS, data }
    );

    const failure = (data: any) => (
        { type: workoutsConstants.WORKOUTS_ALL_FAILURE, data }
    );

    const requestURL = `/v1/workoutWeb/getWorkouts`;
    return (dispatch: Dispatch<any>) => {
        dispatch(request());
        api()
        .get(requestURL)
        .then((response) => { dispatch(success(response.data)); })
        .catch((error) => { dispatch(failure(error)); });
    };
};

